import type {} from '@mui/x-date-pickers/themeAugmentation';
import { createTheme, type Theme } from '@mui/material/styles';
import { createOtaTheme } from '@niaratech/niara-react-form';
type Color = string;
type Options = {
  text?: Color;
  priceColor?: Color;
  primary?: Color;
  primaryReadable?: Color;
  secondary?: Color;
  secondaryReadable?: Color;
  success?: Color;
  danger?: Color;
  warning?: Color;
  info?: Color;
  gray0?: Color;
  gray1?: Color;
  gray2?: Color;
  gray3?: Color;
  gray4?: Color;
  gray5?: Color;
  gray6?: Color;
  fontFamily?: string;
};
export default function (options: Options | Theme = {}): Theme {
  const otaTheme = options && 'palette' in options ? options : createOtaTheme(options as Options);
  return createTheme(otaTheme, {
    typography: {
      fontFamily: 'Manrope, sans-serif',
      fontSize: 14,
      button: {
        fontFamily: 'Manrope, sans-serif'
      }
    },
    shape: {
      borderRadius: 4
    },
    components: {
      // MuiFormControlLabel: {
      //   styleOverrides: {
      //     root: {
      //       fontSize: '14px',
      //     },
      //   },
      // },
      // MuiInputBase: {
      //   styleOverrides: {},
      // },
      MuiInputLabel: {
        defaultProps: {
          // color: 'gray6',
          shrink: true
        },
        styleOverrides: {
          root: {
            fontSize: '14px',
            transform: 'translate(16px,15px) scale(1)'
          },
          shrink: {
            transform: 'translate(0px, -4px) scale(0.7857142857142857)'
          },
          asterisk: {
            color: '#FF0000'
          }
        }
      },
      MuiOutlinedInput: {
        defaultProps: {
          notched: false
        },
        styleOverrides: {
          root: {
            marginTop: '14px',
            '&.Mui-focused': {
              '.MuiOutlinedInput-notchedOutline': {
                borderWidth: 1
              }
            }
          },
          input: {
            padding: '4px 10px',
            fontSize: '16px',
            fontWeight: 400,
            minHeight: '42px',
            height: '42px',
            [`@media (max-width: 1088px)`]: {
              minHeight: '52px',
              height: '52px'
            }
          },
          sizeSmall: {
            fontSize: '14px',
            minHeight: '39px',
            height: '39px'
          }
        }
      },
      MuiAutocomplete: {
        styleOverrides: {
          inputRoot: {
            padding: '7px 9px'
          }
        }
      },
      MuiSelect: {
        styleOverrides: {
          select: {
            fontSize: '16px',
            padding: '1px 10px',
            alignItems: 'center',
            boxSizing: 'border-box',
            minHeight: '42px',
            height: '42px',
            lineHeight: '42px',
            [`@media (max-width: 1088px)`]: {
              minHeight: '52px',
              height: '52px',
              lineHeight: '52px'
            }
          },
          sizeSmall: {
            fontSize: '14px',
            minHeight: '39px',
            height: '39px'
          }
        }
      },
      MuiButton: {
        defaultProps: {
          disableElevation: true
        },
        styleOverrides: {
          root: {
            textTransform: 'none',
            padding: '10px 20px',
            height: '42px',
            maxHeight: '42px',
            minWidth: '42px',
            fontSize: '14px'
          },
          sizeMedium: {
            height: '40px',
            maxHeight: '40px',
            minWidth: '40px',
            fontSize: '14px'
          },
          sizeExtraLarge: {
            height: '56px',
            maxHeight: '56px',
            minWidth: '56px',
            fontSize: '16px',
            fontWeight: 'bold',
            textTransform: 'uppercase'
          },
          sizeLarge: {
            fontSize: '16px'
          },
          sizeInput: {
            height: '42px',
            fontWeight: 'bold',
            maxHeight: '42px',
            minWidth: '42px',
            fontSize: '14px'
          }
        }
      }
    }
  });
}